import classNames from 'classnames'
import { JSX } from 'react'

import { FormMultiselect } from 'cng-common/features/form'
import { TFormMultiselectProps } from 'cng-common/features/form/components/formMultiselect/models'
import { createComponentFn } from 'onboarding/components/helpers/createComponentFn'
import themesStyles from 'onboarding/components/themes.module.scss'

type TComponentFn<T> = (props: TFormMultiselectProps<T>) => JSX.Element

const applyDisabled = <T,>(component: TComponentFn<T>) => {
  return (props: TFormMultiselectProps<T>) => {
    const { isDisabled, classes } = props
    const disabledTheme = isDisabled ? themesStyles.disabledDropdown : undefined

    return component({
      ...props,
      isStatic: true,
      classes: {
        ...classes,
        controlClasses: {
          ...classes?.controlClasses,
          root: classNames(classes?.controlClasses?.root, disabledTheme),
        },
      },
    })
  }
}

export const OnboardingFormMultiselect = <T,>(props: TFormMultiselectProps<T>) =>
  applyDisabled(
    createComponentFn<TFormMultiselectProps<T> & JSX.IntrinsicAttributes>(FormMultiselect)
  )(props)
